(function () {
  const sections = document.querySelectorAll('[data-barf-hero]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbh-js');

    const items = section.querySelectorAll('.fbh-reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbh-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -48px 0px'
    });

    items.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbh-delay')) {
        item.style.setProperty('--fbh-delay', `${index * 110}ms`);
      }
      observer.observe(item);
    });
  });
})();
